import { FormattedMessage } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import { Formula } from '../../../../../typings'
import styles from '../styles'
import { ReviewProps } from './constants'
import { messages } from './messages'

type Props = ReviewProps & {
  config: Formula
}

export function FormulaReview(props: Props) {
  const { config } = props

  return (
    <SummaryRow.Value className={styles.flexRow}>
      <FormattedMessage
        {...messages.formula}
        values={{
          tag: (content) => <Tag>{content}</Tag>,
          formula: config.expression,
        }}
      />
    </SummaryRow.Value>
  )
}
